/* @flow */
import * as React from 'react';

import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

import type { Props as TextProps } from 'components/Text';

type Props = {
  number: number,
  isPercentage?: boolean,
  label?: string,
  labelProps: $Shape<TextProps>,
};

function ErrorCell({ number, isPercentage, label, labelProps }: Props) {
  if (isNaN(number)) {
    return <span />;
  }
  const hasErrors = number > 0;

  if (label && hasErrors) {
    return (
      <TextWithIcon
        glyphColor="lava"
        weight="semibold"
        color="lava"
        icon="explanation-circle"
        iconColor="lava"
        {...labelProps}>
        {label}
      </TextWithIcon>
    );
  }

  const percentage = number * 100;
  const content = isPercentage ? `${percentage.toFixed()}%` : number;
  return (
    <Text
      weight={hasErrors ? 'semibold' : 'normal'}
      color={hasErrors ? 'lava' : 'inherit'}
      {...labelProps}>
      {label || content}
    </Text>
  );
}

export function getErrorCellGenerator(fieldName: string, labelProps?: $Shape<TextProps>) {
  return (data: Object) => {
    return <ErrorCell number={data[fieldName]} labelProps={labelProps || {}} />;
  };
}

export function getErrorPercentageCellGenerator(fieldName: string, labelProps?: $Shape<TextProps>) {
  return (data: Object) => {
    return <ErrorCell number={data[fieldName]} isPercentage labelProps={labelProps || {}} />;
  };
}

export function getErrorTextCellGenerator(
  fieldName: string,
  numberOfErrorsField: string,
  labelProps?: $Shape<TextProps>
) {
  return (data: Object) => {
    return (
      <ErrorCell
        label={data[fieldName]}
        number={data[numberOfErrorsField]}
        labelProps={labelProps || {}}
      />
    );
  };
}
